module.exports = __webpack_public_path__ + "static/media/loading3.8b650cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading3.png
// module id = 188
// module chunks = 0